// atorhome — lightbox for customer photos in the testimonials section (.testimonials-section):
// image + review text caption, arrows, swipe, Esc. Loaded by sections/atorhome-testimonials.liquid.
(function(){
  if (window.atorhomeReviewLightbox) return;
  window.atorhomeReviewLightbox = true;

  var items = [];
  var currentIndex = 0;
  var modal = null;
  var touchStartX = 0;
  var touchStartY = 0;
  var returnFocus = null;

  function cleanText(value){
    return String(value || '').replace(new RegExp('[ \t\n\r]+', 'g'), ' ').trim();
  }

  function isOpen(){
    return modal && modal.getAttribute('aria-hidden') === 'false';
  }

  function stop(event){
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function reviewRoot(){
    return document.querySelector('.testimonials-section');
  }

  function bestImageUrl(img){
    if (!img) return '';
    var srcset = img.getAttribute('srcset') || '';
    if (srcset) {
      var candidates = srcset.split(',').map(function(part){
        var bits = part.trim().split(' ').filter(Boolean);
        var url = bits[0] || '';
        var width = bits[1] && bits[1].indexOf('w') !== -1 ? parseInt(bits[1], 10) || 0 : 0;
        return { url: url, width: width };
      }).filter(function(candidate){ return candidate.url; });
      if (candidates.length) {
        candidates.sort(function(a, b){ return b.width - a.width; });
        return candidates[0].url;
      }
    }
    return img.currentSrc || img.src || img.getAttribute('src') || '';
  }

  function normalizeUrl(url){
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return url;
  }

  function extractedReviewText(card){
    if (!card) return '';
    var cardText = card.querySelector('.testimonial-text');
    if (cardText) {
      return cleanText([cardText.textContent, card.querySelector('.testimonial-name')?.textContent, card.querySelector('.testimonial-location')?.textContent].filter(Boolean).join(' '));
    }
    var clone = card.cloneNode(true);
    clone.querySelectorAll('img,picture,svg,button').forEach(function(el){ el.remove(); });
    var value = cleanText(clone.textContent);
    value = value.replace(new RegExp('[★☆]', 'g'), '');
    value = value.replace(/what\s+our\s+customers\s+say/i, '');
    return cleanText(value);
  }

  function likelyCard(img, root){
    var exactCard = img.closest('.testimonial-card');
    if (exactCard) return exactCard;
    var node = img.parentElement;
    var fallback = img.closest('article, li, .card, .review, .testimonial, .swiper-slide, .slider__slide, [class*="card"], [class*="review"], [class*="testimonial"]');

    while (node && node !== root && node !== document.body) {
      var value = extractedReviewText(node);
      if (value.length >= 18 && value.length <= 900) return node;
      node = node.parentElement;
    }

    return fallback || img.parentElement;
  }

  function refreshItems(){
    var root = reviewRoot();
    if (!root) return [];

    var imgs = Array.prototype.slice.call(root.querySelectorAll('img')).filter(function(img){
      var rect = img.getBoundingClientRect();
      return rect.width > 80 && rect.height > 80 && bestImageUrl(img);
    });

    items = imgs.map(function(img){
      var card = likelyCard(img, root);
      return {
        img: img,
        card: card,
        src: normalizeUrl(img.dataset.full || bestImageUrl(img)),
        review: extractedReviewText(card)
      };
    }).filter(function(item){ return item.src; });

    return items;
  }

  function ensureModal(){
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'ator-review-lightbox';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Customer photos');
    modal.innerHTML = '<button type="button" class="ator-review-lightbox__close" aria-label="Close">&times;</button><button type="button" class="ator-review-lightbox__nav ator-review-lightbox__prev" aria-label="Previous">&#8249;</button><figure class="ator-review-lightbox__figure"><img class="ator-review-lightbox__image" alt="Customer photo"><figcaption class="ator-review-lightbox__caption"></figcaption></figure><button type="button" class="ator-review-lightbox__nav ator-review-lightbox__next" aria-label="Next">&#8250;</button>';
    document.body.appendChild(modal);

    modal.querySelector('.ator-review-lightbox__close').addEventListener('click', function(event){ stop(event); close(); }, true);
    modal.querySelector('.ator-review-lightbox__close').addEventListener('touchend', function(event){ stop(event); close(); }, true);
    modal.querySelector('.ator-review-lightbox__prev').addEventListener('click', function(event){ stop(event); move(-1); }, true);
    modal.querySelector('.ator-review-lightbox__next').addEventListener('click', function(event){ stop(event); move(1); }, true);
    modal.addEventListener('click', function(event){
      stop(event);
      if (event.target === modal) close();
    }, true);
    modal.addEventListener('mousedown', stop, true);
    modal.addEventListener('mouseup', stop, true);

    modal.addEventListener('touchstart', function(event){
      if (!isOpen() || !event.touches || !event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { capture: true, passive: true });

    modal.addEventListener('touchmove', function(event){
      if (isOpen()) event.stopPropagation();
    }, { capture: true, passive: true });

    modal.addEventListener('touchend', function(event){
      if (!isOpen() || !event.changedTouches || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        stop(event);
        move(dx < 0 ? 1 : -1);
      }
    }, true);

    return modal;
  }

  function render(){
    if (!items.length) return;
    var item = items[currentIndex];
    var box = ensureModal();
    var image = box.querySelector('.ator-review-lightbox__image');
    var caption = box.querySelector('.ator-review-lightbox__caption');

    image.src = item.src;
    caption.textContent = item.review || '';
    caption.hidden = !item.review;
    box.classList.toggle('has-caption', Boolean(item.review));
    box.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ator-review-lightbox-open');
    document.body.classList.add('ator-review-lightbox-open');
  }

  function open(index){
    refreshItems();
    if (!items.length) return;
    currentIndex = Math.max(0, Math.min(index, items.length - 1));
    returnFocus = items[currentIndex].img.closest('[data-review-image]') || document.activeElement;
    render();
    modal.querySelector('.ator-review-lightbox__close').focus({ preventScroll: true });
  }

  function close(){
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ator-review-lightbox-open');
    document.body.classList.remove('ator-review-lightbox-open');
    if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
  }

  function move(delta){
    if (!items.length) return;
    currentIndex = (currentIndex + delta + items.length) % items.length;
    render();
  }

  function clickedReviewImage(event){
    var root = reviewRoot();
    if (!root) return null;
    var imageButton = event.target.closest && event.target.closest('[data-review-image]');
    var img = imageButton ? imageButton.querySelector('img') : event.target.closest && event.target.closest('img');
    if (!img || !root.contains(img)) return null;
    return img;
  }

  document.addEventListener('click', function(event){
    if (isOpen()) {
      var closeBtn = event.target.closest && event.target.closest('.ator-review-lightbox__close');
      var prevBtn = event.target.closest && event.target.closest('.ator-review-lightbox__prev');
      var nextBtn = event.target.closest && event.target.closest('.ator-review-lightbox__next');
      stop(event);
      if (closeBtn) close();
      else if (prevBtn) move(-1);
      else if (nextBtn) move(1);
      return;
    }

    var img = clickedReviewImage(event);
    if (!img) return;

    refreshItems();
    var src = normalizeUrl(img.dataset.full || bestImageUrl(img));
    var index = items.findIndex(function(item){ return item.img === img; });
    if (index === -1) index = items.findIndex(function(item){ return item.src === src; });
    if (index === -1) return;

    stop(event);
    open(index);
  }, true);

  document.addEventListener('touchend', function(event){
    if (!isOpen()) return;
    var closeBtn = event.target.closest && event.target.closest('.ator-review-lightbox__close');
    if (closeBtn) {
      stop(event);
      close();
    }
  }, true);

  document.addEventListener('keydown', function(event){
    if (!isOpen()) return;

    if (event.key === 'Tab') {
      var buttons = Array.prototype.slice.call(modal.querySelectorAll('button'));
      var index = buttons.indexOf(document.activeElement);
      if (event.shiftKey && index <= 0) { stop(event); buttons[buttons.length - 1].focus(); }
      else if (!event.shiftKey && (index === -1 || index === buttons.length - 1)) { stop(event); buttons[0].focus(); }
      return;
    }

    if (event.key === 'Escape') {
      stop(event);
      close();
      return;
    }

    if (event.key === 'ArrowLeft') {
      stop(event);
      move(-1);
      return;
    }

    if (event.key === 'ArrowRight') {
      stop(event);
      move(1);
    }
  }, true);
})();
